import { render, staticRenderFns } from "./BusinessMetrics.vue?vue&type=template&id=27ba67b4&scoped=true"
import script from "./BusinessMetrics.vue?vue&type=script&lang=js"
export * from "./BusinessMetrics.vue?vue&type=script&lang=js"
import style0 from "./BusinessMetrics.vue?vue&type=style&index=0&id=27ba67b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba67b4",
  null
  
)

export default component.exports